import React, { useContext, useEffect, useMemo } from "react";
import { Provider, useDispatch, useSelector } from "react-redux";
import { genNewId } from "../util/ids";
import { MasterNode } from "./MasterNode";
import { EditorContext } from "../context/EditorContext/EditorProvider";
import { MainStore } from "../store";
import {
  FINISH_OFFLINE_RENDER,
  FinishOfflineRenderAction,
  START_OFFLINE_RENDER,
  StartOfflineRenderAction
} from "../actions/actionTypes";

export const OfflineAudioComponent = () => {
  const editor = useContext(EditorContext);
  const dispatch = useDispatch();

  const offlineProviderKey = useMemo(
    () => genNewId(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [editor.offlineAudioComponents]
  );

  const isRendering = useSelector<MainStore, boolean>(
    state => state.editorState.isRendering
  );

  // TODO remove the setTimeout: https://trello.com/c/jeJPcwuS
  // For clarity, the setTimeout is to delay the start of the offline render
  // until after the component has been mounted and its nodes and descendants initialized.
  useEffect(() => {
    if (editor.offlineAudioComponents !== null && isRendering) {
      setTimeout(() => {
        editor.offlineAudioComponents.store.dispatch<StartOfflineRenderAction>({
          type: START_OFFLINE_RENDER,
          onRenderComplete: (blob, filename) => {
            dispatch<FinishOfflineRenderAction>({
              type: FINISH_OFFLINE_RENDER
            });
            editor.setOfflineAudioComponents(null);
            editor.offlineAudioComponents.onRenderComplete(blob, filename);
          }
        });
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    editor.offlineAudioComponents,
    editor.setOfflineAudioComponents,
    isRendering,
    dispatch
  ]);

  return editor.offlineAudioComponents ? (
    <Provider
      key={offlineProviderKey}
      store={editor.offlineAudioComponents.store}
    >
      <MasterNode audioMaster={editor.offlineAudioComponents.audioMaster} />
    </Provider>
  ) : (
    <></>
  );
};
